import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rows",
  "use": "icon-rows-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-rows\"><path fill-rule=\"evenodd\" d=\"M4 8v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4H8C5.8 4 4 5.8 4 8m20 18H8a2 2 0 0 1-2-2v-3h20v3a2 2 0 0 1-2 2M6 19v-6h20v6zM26 8v3H6V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol